import type { Component } from "vue";

import ChatAgentToolProactiveCoachingOffer from "./ChatDetail/ChatAgentToolProactiveCoachingOffer.vue";
import ChatEmailDraft from "./ChatDetail/ChatEmailDraft.vue";
import ChatPerformancePicker from "./ChatDetail/ChatPerformancePicker.vue";
import ChatRolePlaySetupForm from "./ChatDetail/ChatRolePlaySetupForm.vue";
import ChatViewRolePlaySummary from "./ChatDetail/ChatViewRolePlaySummary.vue";

// Registry of UI directive components keyed by action name.
// All registered components must accept the same props: { data, messageId, lineIdx }.
// If directive props diverge in the future, consider typing this as a map of
// component name → expected params shape with validation at registration time.
const registry: Record<string, Component> = {
    role_play_setup: ChatRolePlaySetupForm,
    role_play_summary: ChatViewRolePlaySummary,
    pm_picker: ChatPerformancePicker,
    proactive_coaching_offer: ChatAgentToolProactiveCoachingOffer,
    email_draft: ChatEmailDraft,
};

export function resolveDirective(name: string): Component | null {
    return registry[name] || null;
}
